var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFooterYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.6005C8.07441 36.6005 0 28.5237 0 18.5952C0 8.66663 8.07441 0.589844 18 0.589844C27.9256 0.589844 36 8.66663 36 18.5952C36 28.5237 27.9256 36.6005 18 36.6005ZM18 1.81212C8.74891 1.81212 1.22191 9.34133 1.22191 18.5952C1.22191 27.849 8.74891 35.3782 18 35.3782C27.2511 35.3782 34.7781 27.849 34.7781 18.5952C34.7781 9.34133 27.2511 1.81212 18 1.81212Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9495 14.9917C28.8127 13.6705 28.5182 12.2098 27.4344 11.4422C26.5949 10.847 25.4915 10.825 24.4615 10.8262C22.284 10.8274 20.1053 10.8299 17.9279 10.8311C15.8335 10.8336 13.7392 10.8348 11.6448 10.8372C10.7699 10.8384 9.91946 10.77 9.10689 11.1489C8.40918 11.474 7.86298 12.0925 7.53429 12.7806C7.07851 13.7377 6.98321 14.8218 6.92822 15.8803C6.82681 17.8079 6.8378 19.7403 6.95877 21.6666C7.04797 23.0722 7.27402 24.6257 8.3603 25.5216C9.32317 26.3149 10.6819 26.354 11.9307 26.3552C15.8946 26.3589 19.8597 26.3625 23.8248 26.365C24.3332 26.3662 24.8635 26.3564 25.3816 26.3002C26.4006 26.1902 27.372 25.8981 28.027 25.1427C28.688 24.3812 28.8579 23.3215 28.9581 22.318C29.2025 19.8833 29.2 17.4253 28.9495 14.9917ZM15.6356 22.0088V15.1824L21.5448 18.595L15.6356 22.0088Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFooterYtIcon);
export default __webpack_public_path__ + "static/media/web_footer_YT_icon.3da528d2ef81b6e74cd956e35c64c132.svg";
export { ForwardRef as ReactComponent };